export default "__VITE_ASSET__Bz59UOFW__"